import { useSelector, shallowEqual } from "react-redux";
import { ProductDestinationTitle } from "app/pages/.shared/ProductDestinationTitle/ProductDestinationTitle";

const mapStateToProps = state => {
	return {
		shop: state.shop,
	};
};

const ProductDestinationTitleContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	return <ProductDestinationTitle {...props} {...stateProps} />;
};

export default ProductDestinationTitleContainer;
